import axios from "axios";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import api from "../api";
import { INewTemplate } from "../api/services/messaging.service";
import TemplateEditSection from "../components/TemplateEditSection";
import TemplateListSection from "../components/TemplateListSection";

export default function Templates() {
  const [loading, setLoading] = useState<boolean>(false);

  const [templates, setTemplates] = useState<INewTemplate[]>([]);
  const [selectedTemplate, setSelectedTemplate] = useState<INewTemplate | null>(
    null
  );

  useEffect(() => {
    getTemplates();
  }, []);

  async function getTemplates() {
    try {
      setLoading(true);
      let { status, data } = await api.messaging.getTemplates();
      setLoading(false);
      if (status === 200 && data.result) {
        setTemplates(data.result);
      } else {
        toast.error("Error on template fetch");
      }
    } catch (e) {
      setLoading(false);
      if (axios.isAxiosError(e)) {
        if (e.response?.data) {
          toast.error(e.response?.data.errorMessage);
        }
      } else {
        console.log(e);
        toast.error("Something really went wrong!");
      }
    }
  }

  function forceRefresh() {
    getTemplates();
  }

  return (
    <div className="flex grow flex-col items-center">
      {/* Templates */}
      <div className="flex flex-col lg:flex-row mt-10 w-full lg:w-3/4 lg:space-x-8 space-y-8 lg:space-y-0">
        <div className="flex w-full lg:w-2/5">
          <TemplateListSection
            loading={loading}
            templates={templates}
            selectedTemplate={selectedTemplate}
            onSelected={setSelectedTemplate}
          />
        </div>
        <div className="flex w-full lg:w-3/5">
          {selectedTemplate && (
            <TemplateEditSection
              template={selectedTemplate}
              forceRefresh={forceRefresh}
            />
          )}
        </div>
      </div>
    </div>
  );
}
